<template>
  <div class="edit-result">
    <div style="position:relative;">
        <quill-editor
          v-model="ruleForm.editorInfo"
          ref="myQuillEditor"
          :options="editorOption"
          class="article-editor-detail"
          @change="onEditorChange"
        ></quill-editor>
        <div style="position:absolute;top:5px;right: 16px;color: #909399;">
          <el-button type="text" @click="uploadPictureClick">上传图片</el-button>
          <span style="margin-right: 5px;">{{editorInfoText.length}}/1500</span>
        </div>
    </div>
    <div>
      <div class="upload-image" v-if="uploadPicture.uploadPictureShow">
        <el-upload
          :action="'http://huiyi-pro.oss-cn-hangzhou.aliyuncs.com/'"
          list-type="picture-card"
          accept="image/jpeg, image/jpg, image/png"
          :limit="6"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :http-request="picUploadAliyun"
          :on-error="handlePicError"
          :before-upload="beforePicUpload"
          :on-exceed="handleExceed"
          :file-list="uploadPicture.pictureLists"
          >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="uploadPicture.dialogVisible">
          <img width="100%" :src="uploadPicture.dialogPictureUrl" alt="">
        </el-dialog>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="详情标记：" prop="firstSpotCheckState" class="tag-container detailRemark">
          <div class="detail-remark-item">
            <span>问询完整性</span>
            <div>
              <el-radio v-model="detailRemark.wz" label="16" border size="mini" @click.native.prevent="handleDetailRemark('wz','16')"> 收集完整</el-radio>
              <el-radio v-model="detailRemark.wz" label="8" border size="mini"  @click.native.prevent="handleDetailRemark('wz','8')" > 收集不足</el-radio>
            </div>
          </div>
          <div class="detail-remark-item">
            <span>问询顺序性</span>
            <div>
              <el-radio v-model="detailRemark.sx" label="15" border size="mini" @click.native.prevent="handleDetailRemark('sx','15')">逻辑清晰</el-radio>
              <el-radio v-model="detailRemark.sx" label="21" border size="mini" @click.native.prevent="handleDetailRemark('sx','21')">混乱无序</el-radio>
            </div>
          </div>
          <div class="detail-remark-item">
            <span>问询熟练度</span>
            <div>
              <el-radio v-model="detailRemark.sl" label="22" border size="mini" @click.native.prevent="handleDetailRemark('sl','22')">清楚流利</el-radio>
              <el-radio v-model="detailRemark.sl" label="23" border size="mini" @click.native.prevent="handleDetailRemark('sl','23')">生疏含混</el-radio>
            </div>
          </div>
          <div class="detail-remark-item">
            <span>问询态度</span>
            <div>
              <el-radio v-model="detailRemark.td" label="17" border size="mini" @click.native.prevent="handleDetailRemark('td','17')">态度良好</el-radio>
              <el-radio v-model="detailRemark.td" label="9" border size="mini"  @click.native.prevent="handleDetailRemark('td','9')" >态度欠佳</el-radio>
            </div>
          </div>
          <div class="detail-remark-item">
            <span>问卷作答</span>
            <div>
              <el-radio v-model="detailRemark.wj" label="18" border size="mini" @click.native.prevent="handleDetailRemark('wj','18')">记录准确</el-radio>
              <el-radio v-model="detailRemark.wj" label="11" border size="mini" @click.native.prevent="handleDetailRemark('wj','11')">记录有误</el-radio>
            </div>
          </div>
          <div class="detail-remark-item">
            <span>问题回复</span>
            <div>
              <el-radio v-model="detailRemark.hf" label="24" border size="mini" @click.native.prevent="handleDetailRemark('hf','24')">积极灵活</el-radio>
              <el-radio v-model="detailRemark.hf" label="25" border size="mini" @click.native.prevent="handleDetailRemark('hf','25')">刻板迟钝</el-radio>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="质控结果：" prop="result">
          <el-radio-group v-model="ruleForm.result" @change="resultChange">
            <el-radio label="合格"></el-radio>
            <el-radio label="不合格"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="结果标记：" prop="handleResultName">
          <el-radio-group v-model="ruleForm.handleResultName">
            <el-radio label="需注意"></el-radio>
            <el-radio label="需修改问卷"></el-radio>
            <el-radio label="需重拨"></el-radio>
            <el-radio label="无" v-if="ruleForm.result=='合格'"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="质控打分：" prop="qualityScore">
          <el-input-number size="mini" v-model="ruleForm.qualityScore" :step="1" step-strictly :min="0" :max="200"></el-input-number>
        </el-form-item>
        <el-form-item label="优质随访：" prop="isgood" class="isgood-box">
          <el-switch v-model="ruleForm.isgood"></el-switch>
        </el-form-item>
        <el-form-item label="执行坐席：" prop="spotCheckSeatsId" v-if="type == 'add' && (currentFollowState == 4 || currentFollowState == 3)">
          <el-radio-group  v-model="ruleForm.selectSeat">
            <el-radio v-for="(item,index) in seatList" :key="index"
                    :label="item.callCenterUserId">{{item.callCenterUserName}}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item style="height:35px;">
          <span class="btn-span">
            <el-button @click="resetForm('ruleForm')" size="mini">清空内容</el-button>
            <el-button type="primary" @click="submitForm" size="mini" :loading="submitLoading">提交</el-button>
          </span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  RestFeedbackOutControllerUpdateFollowupSpotCheck, //编辑
  RestFeedbackOutControllerAddFollowupSpotCheckRemarks, //我要质控
  RestFeedbackOutControllerGetFollowupTaskCurrentState, //待定
  RestFeedbackOutControllerGetReplayUnqualifiedTaskEnableSeatsList
} from '@src/assets/js/api.js'
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { mapGetters} from "vuex";

export default {
  name: 'EditResult',
  props: ['type','detailData','currentPatientInfo','seatId'],
  data() {
    return {
      currentDetailData: this.detailData,
      editorInfoText: '',
      ruleForm: {
          editorInfo:'<p><br></p>',
          firstSpotCheckState: [],
          isgood: false,
          result:'',
          handleResultName: '',
          qualityScore:""
      },
      rules: {
        firstSpotCheckState:[{required: true, message: '', trigger: ''}],
        result: [{ required: true, message: '', trigger: '' }],
        handleResultName: [{ required: true, message: '', trigger: '' }],
      },
      typeCheckList: [
        { label: '收集不足', value: 8 },
        { label: '态度欠佳', value: 9 },
        // { label: '录音缺失', value: 10 },
        { label: '记录有误', value: 11 },
        { label: '逻辑清晰', value: 15 },
        { label: '收集完整', value: 16 },
        { label: '态度良好', value: 17 },
        { label: '记录准确', value: 18 },
        { label: '混乱无序', value: 21 },
        { label: '清楚流利', value: 22 },
        { label: '生疏含混', value: 23 },
        { label: '积极灵活', value: 24 },
        { label: '刻板迟钝', value: 25 },
      ],
      editorOption: {
        placeholder: "尽可能详细地描述问题，更有利于随访员修正哦~",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ align: [] }]
            ]
          }
        }
      },
      seatList: [], //执行坐席
      currentFollowState: null,
      taskId: localStorage.getItem('taskId'),
      detailRemark:{ //详情标记，完整  顺序 熟练  态度  问卷 回复
        wz:'',
        sx:'',
        sl:'',
        td:'',
        wj:'',
        hf:'',
      },
      submitLoading:false,
      // 上传图片
      uploadPicture:{
        uploadPictureShow:false, //上传图片
        dialogPictureUrl: '',
        dialogVisible: false,
        pictureLists:[]
      },
    }
  },
  components: { quillEditor },
  mounted() {
    this.onLoad()
  },
  computed: {
    ...mapGetters(["username", "userid",]),
  },
  methods: {
    onLoad() {
      this.getTaskStateInfo() //两个都是随访坐席的判断
      // this.getFollowupSpotCheckRemarksList()
      if (this.type == "edit") {
        this.ruleForm = {
          editorInfo:this.currentDetailData.spotCheckRemarks,
          firstSpotCheckState: this.currentDetailData.firstSpotCheckState.substr(1,this.currentDetailData.firstSpotCheckState.length-2).split(','),
          isgood: this.currentDetailData.isGood,
          result: this.currentDetailData.secondSpotCheckState == 1?'合格':'不合格',
          handleResultName: this.currentDetailData.handleResultName?this.currentDetailData.handleResultName:''
        }
        if (this.currentDetailData.imageUrl.length>0) {
          this.getPicUrl(JSON.parse(JSON.stringify(this.currentDetailData.imageUrl)))
        }
        this.detailRemark = this.detailRemarkHandle(this.ruleForm.firstSpotCheckState)
      }
      
    },
    getTaskStateInfo () {
      this.getTaskState()
        .then(res => {
          if (res.status == 0) {
            this.currentFollowState = res.retValue.currentFollowState
            this.getSeatList({ currentFollowState: res.retValue.currentFollowState }).then(seat => {
              this.seatList = seat.retValue
            })
          }
        })
    },
    resultChange(val){
      val=='合格'?this.ruleForm.handleResultName = '无' : this.ruleForm.handleResultName = "";
    },
    onEditorChange ({ quill, html, text }) {
      this.editorInfo = html
      this.editorInfoText = text
    },
        // ================= 上传图片功能====================
    uploadPictureClick(){
      this.uploadPicture.uploadPictureShow=!this.uploadPicture.uploadPictureShow
      
    },
    getPicUrl(picList) {
      let picListAfter = JSON.parse(JSON.stringify(picList))
      if(picListAfter.length>0 && picListAfter[0].indexOf("http") == -1){
        this.$store.dispatch("getPicture", { url: picList }).then(res_ => {
          if (res_) {
            res_.forEach((item,index)=>{
              let temp = {name: picListAfter[index],url:item}
              this.uploadPicture.pictureLists.push(temp)
            })
          }
        });
      }
    },	
    // 上传到oss
    picUploadAliyun(fileObj) {
      let uploadData = {};
      uploadData.file = fileObj.file;
      uploadData.url = uploadData.file.name;
      uploadData.objName = "article/uploadImg/";
      this.$store.dispatch("put", uploadData).then(
        res => {
          if (res.name) {
            this.getPicUrl([res.name])
          }
        },() => {
          this.$message({
            type: "error",
            message: "上传失败！"
          });
        }
      );
    },
    // 处理图片错误
    handlePicError() {
      console.log("上传失败 ", arguments);
    },
    // 上传图片前处理
    beforePicUpload() {
      console.log("before Icon", arguments);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`限制上传 6 张图片！`);
    },
    handleRemove(file, fileList) {
      this.uploadPicture.pictureLists = fileList
    },
    handlePictureCardPreview(file) {
      this.uploadPicture.dialogPictureUrl = file.url;
      this.uploadPicture.dialogVisible = true;
    },
    submitForm() {
      let vm = this
      if(vm.editorInfoText.length>1500){
        vm.$message.error(`质控详情字数当前为${vm.editorInfoText.length} ,请勿超过1500字`)
        return
      }
      // 详情标记
      vm.ruleForm.firstSpotCheckState=[]
      for (let i in vm.detailRemark) { 
        if(vm.detailRemark[i]){
          vm.ruleForm.firstSpotCheckState = vm.ruleForm.firstSpotCheckState.concat(vm.detailRemark[i])
        }
      }

      if (vm.ruleForm.firstSpotCheckState.length == 0) {
        vm.$message.warning("请对质控内容进行标记")
        return
      }
      if (vm.ruleForm.result == "") {
        vm.$message.warning("请选择质控结果")
        return
      }
      if (vm.ruleForm.handleResultName == "") {
        vm.$message.warning("请选择质控结果标记")
        return
      }
      let data = {
        spotCheckUserType: 2, //2: 呼叫台
        followUpTaskId: this.taskId,
        followupPatientId: this.currentPatientInfo.followupPatientId*1,
        followUpTaskPatientInfoId: this.currentPatientInfo.followupPatientInfoId*1,
        spotCheckSeatsId: this.seatId*1,
        firstSpotCheckState: vm.ruleForm.firstSpotCheckState==[]?'':`,${vm.ruleForm.firstSpotCheckState.join(',')},`,//非必填项  详情标记
        secondSpotCheckState: vm.ruleForm.result == '合格'?1:0,//质控结果    合格：1  不合格：0
        spotCheckRemarks: vm.ruleForm.editorInfo, //非必填项  编辑器中内容
        spotCheckUserId: this.userid,
        spotCheckUserName: this.username,//当前用户
        followupPatientName: this.currentPatientInfo.patientName,
        hospitalId: this.currentPatientInfo.adminNo*1,
        isGood: vm.ruleForm.isgood, //是否标记为优质
        adminNo: this.currentPatientInfo.hospitalId,
        handleResult: this.getHandleresultToNum(vm.ruleForm.handleResultName), //结果标记
        appointSeatsId: this.ruleForm.selectSeat || null,
        imageUrl: this.uploadPicture.pictureLists.map(it => it.name),
        qualityScore: this.ruleForm.qualityScore || null
      }
      this.submitLoading=true
      if(this.type == 'add'){
        this.addFollowupSpotCheckRemarksAsync(data).then(res => {
          if (res.status == 0) {
                this.$message.success('提交成功')
                this.ruleForm= {
                    editorInfo:'<p><br></p>',
                    firstSpotCheckState: [],
                    isgood: false,
                    result:'',
                    handleResultName: ''
                }
                this.uploadPicture={
                  uploadPictureShow:false, //上传图片
                  dialogPictureUrl: '',
                  dialogVisible: false,
                  pictureLists:[]
                },
                this.hadAddQc()
                this.submitLoading=false
              } else {
                this.$message.error(res.desc)
                this.submitLoading=false
              }
        })
      }else {
        this.updateFollowupSpotCheckAsync(data).then(res => {
          if (res.status == 0) {
                this.$message.success('修改成功')
                this.hadAddQc()
                this.submitLoading=false
              } else {
                this.$message.error(res.desc)
                this.submitLoading=false
              }
        })
      }
    },
    hadAddQc(){
      this.$emit('hadAddQc', true)
    },
    // 详情标记的单选再次点击可以取消
    handleDetailRemark(type,val){
      val == this.detailRemark[type] ? this.detailRemark[type] = '' : this.detailRemark[type] = val
    },
    resetForm(formName) {
      this.ruleForm= {
          editorInfo:'<p><br></p>',
          firstSpotCheckState: [],
          isgood: false,
          result:'',
          handleResultName: ''
      }
      this.detailRemark = {
        wz:'',
        sx:'',
        sl:'',
        td:'',
        wj:'',
        hf:'',
      }
      this.uploadPicture={
        uploadPictureShow:false, //上传图片
        dialogPictureUrl: '',
        dialogVisible: false,
        pictureLists:[]
      }
    },
    // 处理编辑时的详情标记
    detailRemarkHandle(paramArr){
      let temp={wz:'',sx:'',sl:'',td:'',wj:'',hf:''}
      paramArr.forEach(item => {
        if(item == '16'||item == '8' ){temp.wz = item}
        if(item == '15'||item == '21'){temp.sx = item}
        if(item == '22'||item == '23'){temp.sl = item}
        if(item == '17'||item == '9' ){temp.td = item}
        if(item == '18'||item == '11'){temp.wj = item}
        if(item == '24'||item == '25'){temp.hf = item}
      })
      return temp
    },
    
    getHandleresultToNum(state) {
      switch (state) {
        case '需重拨':
          return 1
          break
        case '需注意':
          return 2
          break
        case '平台相关':
          return 3
          break
        case '需修改问卷':
          return 4
          break
        case '无':
          return 5
          break
      }
    },
    // ====================================
    async getTaskState () {
      let request = new RestFeedbackOutControllerGetFollowupTaskCurrentState()
      request.p_followUpTaskId = this.taskId
      request.p_followUpTaskPatientInfoId = this.currentPatientInfo.followupPatientInfoId
      request.p_followUpPatientId = this.currentPatientInfo.followupPatientId
      await request.send()
      return request.result
    },
    async getSeatList (p) {
      let request = new RestFeedbackOutControllerGetReplayUnqualifiedTaskEnableSeatsList()
      request.p_currentFollowState = p.currentFollowState
      request.p_followUpTaskId = this.taskId
      request.p_followUpTaskPatientInfoId = this.currentPatientInfo.followupPatientInfoId
      await request.send()
      return request.result
    },
    async addFollowupSpotCheckRemarksAsync(p) {
      let request = new RestFeedbackOutControllerAddFollowupSpotCheckRemarks()
      request.p_spotCheckUserId = p.spotCheckUserId
      request.p_spotCheckUserType = p.spotCheckUserType
      request.p_followUpTaskId = p.followUpTaskId
      request.p_followupPatientId = p.followupPatientId
      request.p_followUpTaskPatientInfoId = p.followUpTaskPatientInfoId
      request.p_spotCheckSeatsId = p.spotCheckSeatsId
      request.p_firstSpotCheckState = p.firstSpotCheckState
      request.p_secondSpotCheckState = p.secondSpotCheckState
      request.p_spotCheckRemarks = p.spotCheckRemarks
      request.p_spotCheckUserName=p.spotCheckUserName
      request.p_followupPatientName=p.followupPatientName
      request.p_admitNo=p.adminNo
      request.p_isGood = p.isGood
      request.p_handleResult = p.handleResult
      request.p_appointSeatsId = p.appointSeatsId
      request.p_imageUrl = p.imageUrl
      request.p_qualityScore = p.qualityScore
      await request.send()
      return request.result
    },
    
    async updateFollowupSpotCheckAsync(p) {
      let request = new RestFeedbackOutControllerUpdateFollowupSpotCheck()
      request.p_id= this.currentDetailData.id
      request.p_nowUserId = sessionStorage.getItem('userid')
      request.p_followupPatientInfoId = p.followUpTaskPatientInfoId
      request.p_firstSpotCheckState = p.firstSpotCheckState
      request.p_spotCheckRemarks = p.spotCheckRemarks
      request.p_secondSpotCheckState = p.secondSpotCheckState
      request.p_isGood = p.isGood
      request.p_handleResult = p.handleResult
      request.p_imageUrl = p.imageUrl
      request.p_qualityScore = p.qualityScore
      
      await request.send()
      return request.result
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-result {
  margin-bottom: 10px;
  .tag-container {
    margin-top: 8px;
    display: flex;
    flex-wrap:wrap;
    .detail-remark-item {
      display: flex;
      // border: 1px solid #ccc;
      flex-direction: column;
      margin-right: 10px;
      &>span {
        height: 26px;
        padding-left: 10px;
        color: #909399;
      }
      // 详情标记单选项 交互效果
      .el-radio.is-bordered {
          border: 1px solid #F5F5F5;
          background: #F5F5F5;
          border-radius: 15px;
        }
        .el-radio.is-bordered:hover {
          color: #409EFF;
        }
        .el-radio.is-bordered.is-checked {
          border-color: #409EFF;
          background: #fff;
        }
    }
  }
}

</style>
<style  lang="scss" >
.edit-result {
  .upload-image {
    margin: 22px 15px 0 15px;
    .el-upload-list--picture-card .el-upload-list__item {
      width: 60px;
      height: 60px;
    }
    .el-upload--picture-card{
      width: 60px;
      height: 60px;
      line-height: 60px;
    }
  }
  .el-form-item {
    margin-bottom: 0px;
    label{
      padding-top: 10px;
    }
  }
  .isgood-box {
    height: 30px;
    &>label{
      padding-top: 5px;
    }
  }
  .tag-container {
    .el-form-item__content{
      margin-left:0px !important;
      display: flex;
      flex-wrap:wrap;
      flex: 1;
    }
  }
  .detailRemark label{
    padding-top: 5px;
  }
  .el-form-item__label {
    line-height: 30px;
  }
  .el-form-item__content {
    position: relative;
    .btn-span {
      position: absolute;
      right: 10px;
    }
    .el-form-item__error {
      display: none;
    }
  }

  .tag-container {
    .el-radio {
      margin: 0 5px 10px 5px;
    }
    .el-checkbox.is-bordered+.el-checkbox.is-bordered {
      margin-left: 5px;
    }
    .el-radio__input {
      display: none;
    }
    .el-radio__label{
      padding-left: 0px;
    }
    .el-radio--mini.is-bordered {
      padding: 6px 8px 0 8px;
      margin: 0 5px;
    }
  }
  .article-editor-detail {
    margin: 10px;
    height: 180px;
    .ql-container {
      height: 140px;
      font-size: 14px;
    }
    .ql-editor {
      min-height: 140px;
      height: 140px;
    }
  }
  .ql-editor ol, .ql-editor ul {
    padding-left: 0;
  }
}
</style>
